import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@core-layout/app/app.module';
import { HybridService } from 'app/modules/core-modules/hybrid/hybrid.service';
import { environment } from 'environments/environment';
import { hmrBootstrap } from 'hmr';

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

// if (environment.hmr) {
//     // bootstrap().catch(err => console.log(err));
//     // eslint-disable-next-line @typescript-eslint/dot-notation
//     if (module['hot']) {
//         hmrBootstrap(module, bootstrap);
//     }
//     else {
//         console.error('HMR is not enabled for webpack-dev-server!');
//         console.log('Are you using the --hmr flag for ng serve?');
//     }
// }
// else {
bootstrap().then(() => {
    if ('serviceWorker' in navigator && (environment.production || environment.stage)) {
        navigator.serviceWorker.getRegistrations()
            .then(registrations => {
                for (const registration of registrations) {
                    registration.unregister().catch(err => console.error(err));
                }
            })
            .catch((err) => console.error(err));
    }
}).catch(err => console.log(err));
// }
